export interface SingleTrail extends Trails {
    [key: string]: any; // Add an index signature to allow indexing with a string
    description: string;
    trailPath: trailPath;
    startingPoint?: startingPoint;
  }

  interface startingPoint {
    coordinates: [number, number];
    type: string
  }
  
  interface trailPath {
    type: string;
    coordinates: [number, number, number][];
  }

  // Utility functions for time/interval conversion
  export const formatHoursToInterval = (hours: number | string | null | undefined): string => {
    // Handle null, undefined, or invalid values
    if (!hours && hours !== 0) return "0 hours 0 minutes";
    
    // Convert to number if it's a string
    const numericHours = typeof hours === 'string' ? parseFloat(hours) : Number(hours);
    
    // Handle invalid numbers
    if (isNaN(numericHours) || numericHours < 0) return "0 hours 0 minutes";
    
    const wholeHours = Math.floor(numericHours);
    const minutes = Math.round((numericHours - wholeHours) * 60);
    return `${wholeHours} hours ${minutes} minutes`;
  };

  export const parseIntervalToHours = (intervalInput: string | number | null | undefined | {hours?: number, minutes?: number}): number => {
    // Handle null, undefined, or empty values
    if (intervalInput === null || intervalInput === undefined || intervalInput === '') return 0;
    
    // If it's already a number, return it directly
    if (typeof intervalInput === 'number') {
      return isNaN(intervalInput) ? 0 : intervalInput;
    }
    
    // Handle TimeInterval object format like {hours: 1, minutes: 30}
    if (typeof intervalInput === 'object' && intervalInput !== null) {
      const timeObj = intervalInput as {hours?: number, minutes?: number};
      const hours = timeObj.hours || 0;
      const minutes = timeObj.minutes || 0;
      const result = hours + (minutes / 60);
      console.log('Parsed object format:', intervalInput, '→', result);
      return result;
    }
    
    // Convert to string if it's not already
    const intervalString = String(intervalInput).trim();
    
    // Handle empty string after conversion
    if (!intervalString) return 0;
    
    // Handle PostgreSQL interval format like "02:30:00" or "2:30:00"
    const timeMatch = intervalString.match(/(\d{1,2}):(\d{2}):(\d{2})/);
    if (timeMatch) {
      const hours = parseInt(timeMatch[1], 10);
      const minutes = parseInt(timeMatch[2], 10);
      return hours + (minutes / 60);
    }
    
    // Handle text format like "2 hours 30 minutes"
    const hourMatch = intervalString.match(/(\d+)\s*hours?/i);
    const minuteMatch = intervalString.match(/(\d+)\s*minutes?/i);
    
    const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
    const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;
    
    return hours + (minutes / 60);
  };

  export interface Trails {
    createdAt: Date;
    cityId: number;
    name: string;
    id: number;
    status: TrailStatus;
    distance?: number;
    elevationGain?: number;
    difficulty: TrailDifficulty;
    type?: TrailType;
    carType?: CarType;
    time: string | {hours?: number, minutes?: number}; // Backend can return string or object format
    photos?: string[];
    rating: number;
    tags?: TrailTag[];
  }

  export interface TrailTag {
    id: number;
    name: string;
  }


export interface Waypoint {
  name: string;
  id: number;
  location: number[];
  description: string;
  photos: string;
  createdat: Date;
};

  export enum TrailStatus {
    Active = 'active',
    Deleted = 'deleted',
    Pending = 'pending'
}

export enum TrailDifficulty {
    Easy = 'Easy',
    Moderate = 'Moderate',
    Challenging = 'Challenging',
    Expert = 'Expert'
}

export enum TrailType {
    Loop = 'Loop',
    Out_Back = 'Out_Back',
    Semi_Loop = 'Semi_Loop',
    One_Way = 'One_Way',
}

export enum CarType {
    _4x4 = '_4x4',
    Sedan = 'Sedan',
    SUV = 'SUV',
}
